export default {
  container: {
    width: "100%",
    // marginY: "calc(1 * var(--rhythm))",
  },

  title: {
    marginY: "calc(0.5 * var(--rhythm))",
  },

  wrapper: {
    maxWidth: "100%",
    overflowX: "auto",
    table: {
      tableLayout: "fixed",
    },
    th: {
      boxSizing: "border-box",
      height: "calc(2.5 * var(--rhythm))",
      p: 0,
      color: "var(--color-black)",
      backgroundColor: "var(--color-background)",
      border: "1px solid var(--color-border)",
    },
    td: {
      boxSizing: "border-box",
      height: "calc(2.5 * var(--rhythm))",
      p: 0,
      border: "1px solid var(--color-border)",
    },
  },
};
